import React, { useEffect, useState } from "react";
import "./DrawerSub.scss";
import { getHeadersWoman } from "../../../services/headers/headers";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link } from "react-router-dom";

function DrawerSub({ gender, onBack }) {
  const [data, setData] = useState([]);
  const [cateList, setCateList] = useState([]);
  const [featuredList, setFeaturedList] = useState([]);
  const [boxList, setBoxList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      if (gender === "Nữ") {
        const res = await getHeadersWoman();
        setData(res);
        if (res && res.length > 0) {
          const data = res[0];
          setCateList(data.cate || []);
          setFeaturedList(data.featured || []);
          setBoxList(data.box_img || []);
        }
      } else {
        setCateList([]);
        setFeaturedList([]);
        setBoxList([]);
      }
    };
    fetchData();
  }, [gender]);

  return (
    <div className="drawer-sub-wrapper">
      <div className="sub-header">
        <button className="back-btn" onClick={onBack}>
          <FaArrowLeftLong className="icon-back-btn" />
        </button>
      </div>

      <div className="sub-categories">
        {cateList.map((c) => (
          <Link to={`${data[0]?.name}/${c.key}`}>
            <div key={c.id} className="sub-cate-item">
              {c.name}
            </div>
          </Link>
        ))}
      </div>

      <div className="sub-featured">
        {featuredList.map((f) => (
          <Link to={`${data[0]?.name}/${f.key}`}>
            <div key={f.id} className="sub-featured-item">
              {f.name}
            </div>
          </Link>
        ))}
      </div>

      <div className="sub-box-img">
        {boxList.map((b) => (
          <div key={b.id} className="sub-box-item">
            <img src={b.thumbnail} alt={b.name} />
            <span>{b.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DrawerSub;
